import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const forms = {
  emailSignUpForm: 'EMAIL_SIGNUP_FORM',
  oneTimeCodeForm: 'ONE_TIME_CODE_FORM',
} as const;

type OneOfAuthForms = (typeof forms)[keyof typeof forms];

export interface AuthFormState {
  currentForm: OneOfAuthForms;
  email: string;
  newPassword: string;
}

const initialState: AuthFormState = {
  currentForm: forms.emailSignUpForm,
  email: '',
  newPassword: '',
};

export const authFormSlice = createSlice({
  name: 'authForm',
  initialState,
  reducers: {
    switchAuthForm(state, action: PayloadAction<OneOfAuthForms>) {
      state.currentForm = action.payload;
    },
    updateEmail(state, action: PayloadAction<string>) {
      state.email = action.payload;
    },
    updateNewPassword(state, action: PayloadAction<string>) {
      state.newPassword = action.payload;
    },
  },
});

export const { switchAuthForm, updateEmail, updateNewPassword } = authFormSlice.actions;
